import axios from "axios";
import ErrorParser from '../error.parser';

const HistoricalService = {
    timeseries: async function () {
        const requestData = {
            method: "get",
            url: "/api/viewer/historical/timeseries",
        };
        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = ErrorParser.asMessage(error);
            throw new Error(message);
        }
    },
    observations: async function (oc_id, from, to, onlyValidValues, viewAsBar, meantype, coverage) {
        const requestData = {
            method: "post",
            url: "/api/viewer/historical/observations",
            data: { oc_id, from, to, onlyValidValues, viewAsBar, meantype, coverage }
        };
        console.log("REQUEST", requestData);

        try {
            const response = await axios(requestData);
            return response.data;
        } catch (error) {
            const message = ErrorParser.asMessage(error);
            throw new Error(message);
        }
    },
    timeSeriesCsv: async function (selection, pivot) {
        try {
            var url = "/api/viewer/historical/csv/timeseries"
            if (pivot) url = "/api/viewer/historical/csv/pivot/timeseries"

            await axios({
                method: "post",
                url: url,
                responsetype: 'blob',
                data: selection
            }).then((response) => {

                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'export.csv');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
        } catch (error) {
            console.log(error);
            const message = error.response.data.message ? error.response.data.message : error.response.data.errors[0].message;
            throw new TimeseriesError(error.response.status, message);
        }
    }
};

export default HistoricalService;
